import "./lib/lazyload";

const $imgs = $(".content").find("img");
let $set;
let images = [];

$imgs.each((index, elem) => {
  const $this = $(elem);
  const src = $this.attr("src");

  const $newImg = $this
    .clone()
    .attr("data-src", src)
    .attr("src", "/article/loading.gif");

  images.push(src);

  if ($set) {
    $set = $set.add($newImg);
  } else {
    $set = $newImg;
  }

  $this.replaceWith($newImg);
});

$(".content").removeClass("hideImage");

if ($set && $set.length > 0) {
  var flag = false;
  var img = new Image();
  img.src = "/article/loading.gif";

  if (img.complete) {
    flag = true;
    $set.lazyload();
  }

  img.onload = function () {
    if (flag === false) {
      $set.lazyload();
    }
  };

  if (
    /ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase()) &&
    global.zt
  ) {
    console.log("==============================");
    console.log("图片事件点击事件绑定");

    $(".content").on("click", "img", function () {
      const $img = $(this);

      if ($img.parentsUntil(".content").filter("a[href]").length > 0) {
        return;
      }

      console.log("==============================");
      console.log("调用宝盒sdk图片查看方法");
      console.log("参数", images, $set.index($img));

      zt.extend({
        name: "ztoBoxOpenImage",
        params: {
          images,
          currentIndex: $set.index($img),
        },
        success(res) {
          console.log(res);
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/_source-map-loader@0.2.4@source-map-loader!./src/lazyload.js